let measureNode = null;

const getMeasureNode = () => {
  if (measureNode || typeof document === 'undefined') return measureNode;
  const node = document.createElement('div');
  node.style.position = 'absolute';
  node.style.visibility = 'hidden';
  node.style.left = '-99999px';
  node.style.top = '-99999px';
  node.style.pointerEvents = 'none';
  node.style.whiteSpace = 'pre-wrap';
  node.style.wordBreak = 'break-word';
  node.style.overflowWrap = 'break-word';
  node.style.padding = '0';
  node.style.margin = '0';
  node.style.boxSizing = 'content-box';
  document.body.appendChild(node);
  measureNode = node;
  return measureNode;
};

export const measureTextBox = ({
  text = '',
  fontSize = 16,
  fontFamily = 'Inter, sans-serif',
  fontWeight = 400,
  fontStyle = 'normal',
  lineHeight = 1.2,
  letterSpacing = 0,
  wrapWidth,
  autoWidth = true,
  paddingX = 0,
  paddingY = 0,
  minW = 40,
  minH = 24,
} = {}) => {
  const safeLineHeight = lineHeight || 1.2;
  if (typeof document === 'undefined') {
    const approxWidth = Math.max(
      minW,
      Math.ceil((text.length || 1) * (fontSize * 0.6)) + paddingX * 2,
    );
    const approxHeight = Math.max(
      minH,
      Math.ceil((fontSize || 16) * safeLineHeight) + paddingY * 2,
    );
    return {
      tightW: approxWidth,
      tightH: approxHeight,
      lineCount: Math.max(String(text).split('\n').length, 1),
    };
  }

  const node = getMeasureNode();
  if (!node) {
    return {
      tightW: Math.max(minW, Math.ceil(fontSize * 2)),
      tightH: Math.max(minH, Math.ceil(fontSize * safeLineHeight)),
      lineCount: Math.max(String(text).split('\n').length, 1),
    };
  }

  node.style.fontSize = `${fontSize || 16}px`;
  node.style.fontFamily = fontFamily || 'Inter, sans-serif';
  node.style.fontWeight = String(fontWeight || 400);
  node.style.fontStyle = fontStyle || 'normal';
  node.style.lineHeight = String(safeLineHeight);
  node.style.letterSpacing = letterSpacing ? `${letterSpacing}px` : '0px';
  if (autoWidth) {
    node.style.whiteSpace = 'pre';
    node.style.wordBreak = 'normal';
    node.style.overflowWrap = 'normal';
    node.style.width = 'auto';
  } else {
    const safeWidth = Math.max(1, Number(wrapWidth || minW) - paddingX * 2);
    node.style.whiteSpace = 'pre-wrap';
    node.style.wordBreak = 'break-word';
    node.style.overflowWrap = 'break-word';
    node.style.width = `${safeWidth}px`;
  }
  node.textContent = text || '';

  const measuredWidth = Math.ceil(node.scrollWidth + paddingX * 2);
  const measuredHeight = Math.ceil(node.scrollHeight + paddingY * 2);
  return {
    tightW: Math.max(measuredWidth, minW),
    tightH: Math.max(measuredHeight, minH),
    lineCount: Math.max(String(text || '').split('\n').length, 1),
  };
};

export const measureTextHeight = ({
  text,
  width,
  fontSize,
  fontFamily,
  fontWeight,
  lineHeight,
  letterSpacing,
  paddingX = 0,
  paddingY = 0,
}) => {
  const { tightH } = measureTextBox({
    text,
    wrapWidth: width,
    autoWidth: false,
    fontSize,
    fontFamily,
    fontWeight,
    lineHeight,
    letterSpacing,
    paddingX,
    paddingY,
  });
  return tightH;
};
